import { ref, provide } from '@vue/composition-api'
import { refundOrderDetail, orderFinished, orderLog, fetchOrderInfo } from '@/api/express/order'
import { Loading, Message, MessageBox } from 'element-ui'
export default function () {
  // const getDetail = inject('getDetail')
  // const visible = inject('visible')
  // const info = inject('info')
  const visible = ref(false)
  const info = ref({})
  const activeStep = ref('0')
  const refundShow = ref(false)
  const refundDetail = ref({})
  const changeShow = ref(false)
  const merchantList = ref([])
  const logList = ref([])
  const logLoading = ref(false)
  const showLog = ref(false)
  const getDetail = async (row) => {
    // expressOrderInfo.value.getDetail(id)
    const { id } = row || {}
    if (!id) {
      return
    }
    Loading.service({ text: '正在加载中～' })
    const { code, data } = await fetchOrderInfo(id)
    if (code === 0) {
      info.value = data
      visible.value = true
    }
    Loading.service().close()
  }
  const close = () => {
    showLog.value = false
    visible.value = false
    info.value = {}
  }
  const showLogData = async () => {
    showLog.value = !showLog.value
    if (showLog.value) {
      logLoading.value = true
      const { code, data } = await orderLog(info.value.id)
      if (code === 0) {
        logList.value = data
      }
      logLoading.value = false
    }
  }
  // 获取退款详情打开退款
  const handleRefund = async () => {
    const { code, data } = await refundOrderDetail(info.value.id)
    if (code === 0) {
      refundDetail.value = data
      refundShow.value = true
    }
  }
  // 改签
  const handleChange = (row) => {
    changeShow.value = true
  }
  // 完成订单
  const onOrderFinished = async (id) => {
    Loading.service()
    const { code } = await orderFinished(id)
    if (code === 0) {
      Message.success('操作成功！')
      showLog.value = false
      getDetail(id)
    }
    Loading.service().close()
  }
  const handleFinish = () => {
    MessageBox.confirm(
      '为保障司机、用户双方权益，请确认司机已将货物送达目的地后再结束该订单',
      '确认是否完成订单？',
      {
        confirmButtonText: '确定',
        cancelButtonText: '稍后看看',
        type: 'warning'
      }
    )
      .then(() => {
        onOrderFinished(info.value.id)
      })
      .catch(() => {
        Message({
          type: 'info',
          message: '已取消'
        })
      })
  }
  // tab锚点
  const onScroll = (e) => {
    const scrollItems = document.querySelectorAll('.scroll-item')
    for (let i = scrollItems.length - 1; i >= 0; i--) {
      // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
      const judge = e.target.scrollTop >= scrollItems[i].offsetTop - scrollItems[0].offsetTop
      if (judge) {
        activeStep.value = i.toString()
        break
      }
    }
  }
  const handleSelect = (index) => {
    const target = document.querySelector('.scroll_cls')
    const scrollItems = document.querySelectorAll('.scroll-item')
    // 判断滚动条是否滚动到底部
    if (target.scrollHeight <= target.scrollTop + target.clientHeight) {
      activeStep.value = index
    }
    const total = scrollItems[index].offsetTop - scrollItems[0].offsetTop // 锚点元素距离其offsetParent(这里是body)顶部的距离(待滚动的距离)
    let distance = document.querySelector('.scroll_cls').scrollTop // 滚动条距离滚动区域顶部的距离
    // let distance = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset // 滚动条距离滚动区域顶部的距离(滚动区域为窗口)
    // 滚动动画实现, 使用setTimeout的递归实现平滑滚动，将距离细分为50小段，10ms滚动一次
    // 计算每一小段的距离
    let step = total / 50
    if (total > distance) {
      smoothDown(document.querySelector('.scroll_cls'))
    } else {
      const newTotal = distance - total
      step = newTotal / 50
      smoothUp(document.querySelector('.scroll_cls'))
    }

    // 参数element为滚动区域
    function smoothDown(element) {
      if (distance < total) {
        distance += step
        element.scrollTop = distance
        setTimeout(smoothDown.bind(this, element), 10)
      } else {
        element.scrollTop = total
      }
    }

    // 参数element为滚动区域
    function smoothUp(element) {
      if (distance > total) {
        distance -= step
        element.scrollTop = distance
        setTimeout(smoothUp.bind(this, element), 10)
      } else {
        element.scrollTop = total
      }
    }

    document.querySelectorAll('.scroll-item').forEach((item, index1) => {
      if (index === index1) {
        item.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      }
    })
  }

  provide('refundDetail', refundDetail)
  provide('refundShow', refundShow)
  provide('changeShow', changeShow)
  provide('info', info)
  provide('merchantList', merchantList)
  provide('getDetail', getDetail)
  return {
    activeStep,
    info,
    visible,
    close,
    handleSelect,
    onScroll,
    handleRefund,
    refundDetail,
    refundShow,
    changeShow,
    handleChange,
    merchantList,
    onOrderFinished,
    handleFinish,
    showLogData,
    logLoading,
    showLog,
    logList,
    getDetail
  }
}
